import api from '../../api';

export type BanquetCategorySummary = {
  id: string;
  labelJa: string;
  themeColor: string;
  sortOrder: number;
  figureCount: number;
};

export type BanquetFigureSummary = {
  slug: string;
  nameJa: string;
  categoryId: string;
  rosterGroup: number;
  living: boolean;
  hasArticle: boolean;
  episodeNumber: number | null;
  titleJa?: string | null;
  summaryJa?: string | null;
};

export type BanquetHub = {
  title: string;
  disclaimer: string;
  youtubeChannelUrl: string;
  categories: BanquetCategorySummary[];
  featured: (BanquetFigureSummary & { titleJa: string }) | null;
};

export type BanquetCategoryPage = {
  id: string;
  labelJa: string;
  themeColor: string;
  disclaimer: string;
  figures: BanquetFigureSummary[];
};

export type BanquetArticleSection = {
  id: string;
  heading: string;
  body: string;
};

export type BanquetFigurePage = {
  slug: string;
  nameJa: string;
  categoryId: string;
  categoryLabelJa: string;
  themeColor: string;
  rosterGroup: number;
  living: boolean;
  disclaimer: string;
  summaryJa?: string | null;
  article: {
    titleJa: string;
    episodeNumber: number | null;
    publishedOn: string | null;
    youtubeUrl: string | null;
    tiktokUrl: string | null;
    body: {
      lead?: string;
      sections?: BanquetArticleSection[];
      closing?: string;
      sourcesNote?: string;
      disclaimer?: string;
    };
  } | null;
};

export const banquetService = {
  async getHub(): Promise<BanquetHub> {
    const res = await api.get<{ success: boolean; data: BanquetHub }>('/banquet/public/hub');
    return res.data.data;
  },
  async getCategory(id: string): Promise<BanquetCategoryPage> {
    const res = await api.get<{ success: boolean; data: BanquetCategoryPage }>(
      `/banquet/public/categories/${encodeURIComponent(id)}`
    );
    return res.data.data;
  },
  async getFigure(slug: string): Promise<BanquetFigurePage> {
    const res = await api.get<{ success: boolean; data: BanquetFigurePage }>(
      `/banquet/public/figures/${encodeURIComponent(slug)}`
    );
    return res.data.data;
  },
};
